import CommunityGuide from "../Components/Policies/CommunityGuideLines";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import PrivacyPol from "../Components/Policies/PrivacyPol";
import './legalpage.css'
const PrivacyPage=()=>{
    return(
        <>
        <Header/>
        <div style={{padding:"3% 7%"}}>
            
        <div className="headingterms" style={{fontWeight:"bold",color:"#061A32",fontFamily:"Poppins",marginBottom:"20px"}} >Privacy and Policy</div>
        <PrivacyPol/>
        </div>
        <Footer/>
        </>
    )
}
export default PrivacyPage;